import { ScrollReveal, ScrollRevealGroup } from '@podus/ui';

const statements = [
  'We don’t run background checks; we de-risk your life.',
  'If something goes wrong, our intelligence file cuts investigation time significantly.',
  'When people know they’ve been deeply vetted, behaviour changes.',
  'A bad domestic hire can cost you millions, trauma, or your family’s safety. ₦400,000 is cheaper than regret.',
];

export default function WhyItMatters() {
  return (
    <section className='w-full bg-[#14171A] px-4 md:px-6 lg:px-10 py-12 md:py-14'>
      <div className='w-full mx-auto'>
        <ScrollReveal variant='fade-up'>
          <h2 className='text-2xl md:text-3xl font-bold text-white text-center mb-6 md:mb-8'>Why it matters</h2>
        </ScrollReveal>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4'>
          <ScrollRevealGroup variant='fade-up' stagger={120}>
            {statements.map((statement, index) => (
              <div
                key={index}
                className='h-full bg-white/5 border border-white/10 rounded-xl p-4 flex items-start gap-3 transition-all duration-300 hover:-translate-y-1 hover:bg-white/10 hover:border-[#FF6B35]/40'
              >
                <span className='text-[#FF6B35] text-lg font-bold leading-none shrink-0'>•</span>
                <p className='text-gray-200 text-sm md:text-[15px] leading-snug'>{statement}</p>
              </div>
            ))}
          </ScrollRevealGroup>
        </div>

        <ScrollReveal variant='fade' delay={150}>
          <p className='text-gray-400 text-sm md:text-[15px] leading-snug text-center max-w-[820px] mx-auto mt-6 md:mt-8'>
            We help families and businesses make high-trust hires by combining human intelligence, field verification,
            and behavioural risk analysis to filter malicious intent before it becomes a costly mistake.
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}
